import React from 'react';
import { CircularProgress } from '@material-ui/core';
import LoaderLogo from '../../images/loaderLogo.svg';

import './styles/configLoader.less';

function ConfigLoader() {
  return (
    <div className="config-loader-container">
      <div className="logo-container">
        <img src={LoaderLogo} alt="CompuAccess" className="logo" />
      </div>
      <CircularProgress color="inherit" size={60} />
    </div>
  );
}

export default ConfigLoader;